<template>
  <div class="image-text-setting-position">
    <div class="flex-box">
      <button type="button"
        v-for="option in options"
        :key="option.text"
        :class="['square', option.text, {'inactive': !selected(option.value)}]"
        @click="updateImagePosition(option.value)"
      >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
  ],
  data () {
    return {
      options: [
        { text: 'top', value: 'Top' },
        { text: 'bottom', value: 'Bottom' },
        { text: 'left', value: 'Left' },
        { text: 'right', value: 'Right' },
      ]
    }
  },
  computed: {
    selected: function () {
      return function (option) {
        return option === this.value
      }
    }
  },
  methods: {
    updateImagePosition (value) {
      if (this.value === value) return // 変更がなければ何もしない
      this.$emit('updateImagePosition', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-text-setting-position {
  .square {
    width: 36px;
    height: 36px;
    border: 1px solid $commonFontColor;
    background: white;
    &::before {
      content: '';
      display: block;
      background: $commonFontColor;
    }
    &.inactive {
      border: 1px solid rgba($baseFontColor, 0.3);
      &::before {
        background: rgba($baseFontColor, 0.3);
      }
    }
    &.top {
      &::before {
        width: 30px;
        height: 14px;
        margin: 2px 2px 18px;
      }
    }
    &.bottom {
      &::before {
        width: 30px;
        height: 14px;
        margin: 18px 2px 2px;
      }
    }
    &.left {
      &::before {
        width: 14px;
        height: 30px;
        margin: 2px 18px 2px 2px;
      }
    }
    &.right {
      &::before {
        width: 14px;
        height: 30px;
        margin: 2px 2px 2px 18px;
      }
    }
  }
}
</style>
